module.exports = __webpack_public_path__ + "static/media/md-home.78d6e460.svg";